module.exports = __webpack_public_path__ + "static/media/022.c0001885.jpg";